(function (window, document) {
  'use strict';

  if (window.__libasCollectionFilterUi) return;
  window.__libasCollectionFilterUi = true;

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var openGroups = new Set();
  var activeOpener = null;

  function getPanel() {
    return document.getElementById('CollectionFilterPanel');
  }

  function getCurtain() {
    return document.querySelector('.libas-collection-filter-curtain');
  }

  function isMobile() {
    return mobileQuery.matches;
  }

  function isOpen() {
    var panel = getPanel();
    return Boolean(panel && panel.getAttribute('data-open') === 'true');
  }

  function setOpenersExpanded(expanded) {
    document.querySelectorAll('[data-collection-filter-open]').forEach(function (opener) {
      opener.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function setScrollLock(locked) {
    document.documentElement.classList.toggle('libas-collection-filter-open', locked);
    if (document.body) {
      document.body.classList.toggle('libas-collection-filter-open', locked);
    }
  }

  function focusWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') return;

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function focusAfterPaint(element) {
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        focusWithoutScroll(element);
      }, 0);
    });
  }

  function closePanel(restoreFocus) {
    var panel = getPanel();
    var curtain = getCurtain();
    var openerToRestore = activeOpener;

    if (panel) {
      panel.setAttribute('data-open', 'false');
      if (isMobile()) panel.setAttribute('aria-hidden', 'true');
    }

    if (curtain) curtain.setAttribute('data-open', 'false');
    setOpenersExpanded(false);
    setScrollLock(false);
    activeOpener = null;

    if (restoreFocus && openerToRestore) {
      focusAfterPaint(openerToRestore);
    }
  }

  function openPanel(opener) {
    if (!isMobile()) return;

    var panel = getPanel();
    var curtain = getCurtain();
    if (!panel) return;

    activeOpener = opener;
    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    if (curtain) curtain.setAttribute('data-open', 'true');
    setOpenersExpanded(true);
    setScrollLock(true);

    focusAfterPaint(panel.querySelector('[data-collection-filter-close]'));
  }

  function applyViewportMode() {
    var panel = getPanel();
    if (!panel) return;

    if (isMobile()) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (!isOpen()) panel.setAttribute('aria-hidden', 'true');
      return;
    }

    closePanel(false);
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    panel.removeAttribute('aria-hidden');
  }

  function restoreOpenGroups() {
    var panel = getPanel();
    if (!panel) return;

    panel.querySelectorAll('[data-collection-filter-group]').forEach(function (group) {
      group.open = openGroups.has(group.getAttribute('data-collection-filter-group'));
    });
  }

  function captureInitialOpenGroups() {
    var panel = getPanel();
    if (!panel) return;

    panel.querySelectorAll('[data-collection-filter-group][open]').forEach(function (group) {
      openGroups.add(group.getAttribute('data-collection-filter-group'));
    });
  }

  function toggleFilterList(control, expanded) {
    var list = control.closest('ul.tag-list');
    if (!list) return;

    list.querySelectorAll('.hidden-filters').forEach(function (item) {
      item.style.display = expanded ? 'block' : 'none';
    });

    var showMore = list.querySelector('.show-more-filter-tag');
    var showLess = list.querySelector('.show-less-filter-tag');
    if (showMore) showMore.style.display = expanded ? 'none' : '';
    if (showLess) showLess.style.display = expanded ? 'block' : 'none';
  }

  function trapTab(event, panel) {
    var focusable = Array.prototype.slice.call(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusWithoutScroll(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusWithoutScroll(first);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-collection-filter-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener);
      return;
    }

    var closeControl = event.target.closest('[data-collection-filter-close]');
    if (closeControl) {
      event.preventDefault();
      closePanel(true);
      return;
    }

    var showMore = event.target.closest('.show-more-filter-tag');
    if (showMore) {
      event.preventDefault();
      toggleFilterList(showMore, true);
      return;
    }

    var showLess = event.target.closest('.show-less-filter-tag');
    if (showLess) {
      event.preventDefault();
      toggleFilterList(showLess, false);
      return;
    }

    if (
      isMobile() &&
      isOpen() &&
      event.target.closest('#CollectionFilterPanel .tag-list--active-tags a')
    ) {
      closePanel(false);
    }
  });

  document.addEventListener('input', function (event) {
    if (!isMobile() || !isOpen()) return;
    if (!event.target.closest('#CollectionFilterPanel .filter-form')) return;
    closePanel(false);
  });

  document.addEventListener('toggle', function (event) {
    var group = event.target;
    if (!group.matches || !group.matches('[data-collection-filter-group]')) return;
    if (!group.closest('#CollectionFilterPanel')) return;

    var groupId = group.getAttribute('data-collection-filter-group');
    if (group.open) {
      openGroups.add(groupId);
    } else {
      openGroups.delete(groupId);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!isMobile() || !isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel(true);
      return;
    }

    if (event.key === 'Tab') {
      var panel = getPanel();
      if (panel) trapTab(event, panel);
    }
  });

  document.addEventListener('collection:reloaded', function () {
    restoreOpenGroups();
    applyViewportMode();

    if (typeof window.toggleReadMore === 'function') {
      window.toggleReadMore();
    }
  });

  document.addEventListener('drawerOpen', function () {
    if (isOpen()) closePanel(false);
  });

  document.addEventListener('modalOpen', function () {
    if (isOpen()) closePanel(false);
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', applyViewportMode);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(applyViewportMode);
  }

  window.addEventListener('pageshow', applyViewportMode);

  captureInitialOpenGroups();
  applyViewportMode();
})(window, document);
